module.exports = __webpack_public_path__ + "assets/img/ExtractOne_btn.c2748b2a.png";